import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  headerContainer: {
    padding: 10,
    // borderBottomColor: '#C8C8C8',
    // borderBottomWidth: 1,
  },
  billTo: {
    // color: '#000',
    fontSize: 9,
    fontWeight: 100,
    marginBottom: 5, // added margin to separate lines
  },
});

let CancellationModal = (data, index) => {
  return (
    <Text>
      <Text style={{color:'red'}}>
        {index === 0 ? 'Before' : 'After'}{" "}
        
        {index === 0
          ? moment(data.attributes.DateTo).format('Do MMM YYYY')
          : moment(data.attributes.DateFrom).format('Do MMM YYYY')}
       
      </Text>
      <Text>{`- ${data.attributes.PercentPrice}% of booking amount will be charged`}</Text>
    </Text>
  );
};

const CancellationAccommodationEjunifer = ({ invoice }) => {
  const items1 = JSON.stringify(invoice?.cancellation_policy_ejunifer);
  const items2 = JSON.parse(items1);
  const items3 = JSON.parse(items2);

  // Preparing rows for cancellation policy
  const rowsCancel =
    items3?.CancellationPolicy &&
    items3?.CancellationPolicy.PolicyRules.Rule.map((data, index) => {
      return (
        <Text style={{color:'red'}} key={index}>
          {CancellationModal(data, index)} <br />
        </Text>
      );
    });

  // Free cancellation text
  const constData = (
    <Text style={styles.billTo}>
      Free Cancellation(100% refund) if you cancel this booking before{' '}
      {items3?.CancellationPolicy &&
        items3?.CancellationPolicy.PolicyRules.Rule.length > 0 &&
        moment(
          items3?.CancellationPolicy.PolicyRules.Rule[0].attributes.DateTo
        ).format('Do MMM YYYY')}{' '}
      <br />
    </Text>
  );

  // Charge applicable message
  const Chargeapplicable = (
    <Text style={styles.billTo}>
      The cancellation charges will be applicable as follows:
      <b></b>
    </Text>
  );

  return (
    <View style={{backgroundColor:'#f5f5f5', padding:5, marginTop:5}}>
      {constData}
      {Chargeapplicable}
      <Text style={{fontSize:11, marginBottom:5}}>Cancellation Policy: </Text>
      {rowsCancel}
    </View>
  );
};

export default CancellationAccommodationEjunifer;
